import React, { useState } from 'react';
import { ticketWidgetTag } from '../../../shared/CheckoutEmbedModal/embedSnippets';
import { Badge, Code01, CopyButton, Expand01, Monitor01, Select } from '@opendate-app/setlist';

const EmbedTab = ({ confirm, widgetTemplates = [] }) => {
  const [themeTemplateId, setThemeTemplateId] = useState(null);

  const id = confirm && confirm.id;
  const title = (confirm && confirm.title) || '';
  const src = (confirm && confirm.widget_embed_url) || '';

  const embedCode = src ? ticketWidgetTag(src, `od-confirm-${id}-iframe`, title) : '';
  const themeTemplate = widgetTemplates.find((t) => t.id === Number(themeTemplateId)) || widgetTemplates[0];
  const themedSrc = src && themeTemplate ? new URL(src) : null;
  if (themedSrc) themedSrc.searchParams.set('widget_template_id', themeTemplate.id);
  const themedCode = themedSrc ? ticketWidgetTag(themedSrc.toString(), `od-confirm-${id}-iframe`, title) : '';

  return (
    <div className="cwb-embed-tab">
      <div className="cwb-embed-section">
        <div className="cwb-section-label">Embed Method</div>
        <div className="cwb-embed-methods">
          <div className="cwb-embed-method active">
            <div className="cwb-embed-method-icon">
              <Code01 width={16} height={16} aria-hidden="true" />
            </div>
            <div className="cwb-embed-method-text">
              <div className="cwb-embed-method-name">iFrame Embed</div>
              <div className="cwb-embed-method-desc">Paste into any website</div>
            </div>
          </div>

          <div className="cwb-embed-method disabled">
            <div className="cwb-embed-method-icon">
              <Monitor01 width={16} height={16} aria-hidden="true" />
            </div>
            <div className="cwb-embed-method-text">
              <div className="cwb-embed-method-name">JavaScript Embed</div>
              <div className="cwb-embed-method-desc">More control over styling</div>
            </div>
            <Badge size="sm" color="gray">Coming soon</Badge>
          </div>

          <div className="cwb-embed-method disabled">
            <div className="cwb-embed-method-icon">
              <Expand01 width={16} height={16} aria-hidden="true" />
            </div>
            <div className="cwb-embed-method-text">
              <div className="cwb-embed-method-name">Modal Overlay</div>
              <div className="cwb-embed-method-desc">Opens in a popup</div>
            </div>
            <Badge size="sm" color="gray">Coming soon</Badge>
          </div>
        </div>
      </div>

      <div className="cwb-embed-section">
        <div className="cwb-section-label">Embed Code</div>
        <pre className="cwb-embed-code">{embedCode}</pre>
        <CopyButton value={embedCode} label="Copy Code" copiedLabel="Copied!" />
      </div>

      {widgetTemplates.length > 0 && (
        <div className="cwb-embed-section">
          <div className="cwb-section-label">Theme From Your Site</div>
          <p>
            Let the page embedding this widget choose which of your saved themes to show by adding
            {' '}<code>widget_template_id</code> to the widget URL. Your page decides when to use it,
            for example a dark theme when your site is in dark mode, or a seasonal theme on a holiday page.
          </p>
          <Select
            aria-label="Saved theme"
            value={themeTemplate ? themeTemplate.id : null}
            onChange={(value) => setThemeTemplateId(value)}
            options={widgetTemplates.map((t) => ({ value: t.id, label: `${t.name} (ID ${t.id})` }))}
          />
          <pre className="cwb-embed-code">{themedCode}</pre>
          <CopyButton value={themedCode} label="Copy Code" copiedLabel="Copied!" />
        </div>
      )}
    </div>
  );
};

export default EmbedTab;
